import React, { useEffect, useState } from 'react'

import { Col, Spacer } from '@amzn/stencil-react-components/layout'

import { SmartExpanderContent } from 'src/components/SmartExpander'
import { useBucketsAndCupsGroupEntity } from 'src/hooks/useBucketsAndCupsGroup'
import { BucketsAndCupsGroupEditor } from 'src/pages/module-builder/buckets-and-cups-editor/BucketsAndCupsGroupEditor'
import { ItemEditorValidationErrors } from 'src/pages/module-builder/item-editors/ItemEditorValidationErrors'
import { activityDisplayNameMap } from 'src/pages/module-builder/page-editor/ActivityDropDown'
import { PageEditorProps } from 'src/pages/module-builder/page-editor/PageEditor'
import { PageHeader } from 'src/pages/module-builder/page-editor/PageHeader'

export const BucketsAndCupsGroupPage = ({
    pageIndex,
    moduleEntityId,
    workflowEntityId,
    isLastPage,
    showValidationError,
    locale,
    editDisabled,
    moduleStatus,
    isExpanded,
    onToggleExpand,
}: PageEditorProps) => {
    const { entity } = useBucketsAndCupsGroupEntity({
        workflowEntityId: workflowEntityId,
        moduleEntityId: moduleEntityId,
    })

    const [showError, setShowError] = useState(showValidationError)

    useEffect(() => {
        setShowError(showValidationError ?? false)
    }, [showValidationError])

    useEffect(() => {
        setShowError(showValidationError ?? false)
    }, [showValidationError])

    return (
        <Col gridGap='S300' dataTestId={`page-editor-${pageIndex}`}>
            <Spacer height='S100' />
            <PageHeader
                isLastPage={isLastPage}
                moduleEntityId={moduleEntityId}
                workflowEntityId={workflowEntityId}
                isExpanded={isExpanded}
                pageIndex={pageIndex}
                onclick={onToggleExpand}
                activityName={activityDisplayNameMap.get(entity.type)}
                showValidationError={showError}
                onErrorCheck={setShowError}
                editDisabled={editDisabled}
                runErrorCheckDisabled
                moduleStatus={moduleStatus}
            />
            <SmartExpanderContent isExpanded={isExpanded}>
                {() => (
                    <>
                        <ItemEditorValidationErrors
                            dataTestId='generic-errors'
                            itemId={workflowEntityId}
                            showValidationError={showError}
                        />
                        <BucketsAndCupsGroupEditor
                            moduleEntityId={moduleEntityId}
                            workflowEntityId={workflowEntityId}
                            showValidationErrors={!!showValidationError}
                            locale={locale}
                            editDisabled={editDisabled}
                        />
                        <Spacer height='S400' />
                    </>
                )}
            </SmartExpanderContent>
        </Col>
    )
}
